import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'tangram-suggested-content-list',
  templateUrl: './suggested-content-list.component.html',
  styleUrls: ['./suggested-content-list.component.scss']
})
export class SuggestedContentListComponent {
  @Input() items: Array<{ title: string; url: string; reason: string; source: string; selected: boolean }> = [];
  @Output() itemToggled = new EventEmitter<number>();
  @Output() itemUsed = new EventEmitter<{ title: string; url: string }>();
}
